import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceDot,
} from "recharts";

const UVIndexChart = ({ lat, lng }) => {
  // const [uvData, setUvData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  // const API_KEY = "1b8262cc537de03f4d96fc460c42f10b"; // Replace with your API key
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    const formatter = new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Sydney",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
      hour12: false,
    });

    const fetchUVIndex = async () => {
      try {
        console.log("Current UV data lat lng", lat + "|" + lng);
        // const response = await fetch(
        //   `https://api.openweathermap.org/data/3.0/onecall?lat=${lat}&lon=${lng}&exclude=current,minutely,daily,alerts&appid=${API_KEY}`
        // );
        const response = await fetch(
          `https://currentuvindex.com/api/v1/uvi?latitude=${lat}&longitude=${lng}`
        );
        console.log("Current UV response", response);
        const data = await response.json();
        console.log("Current UV data", data);

        // Get current time in UTC
        const currentTime = new Date(data.now.time);
        const sydneyCurrentTime = formatter.format(currentTime);
        console.log("sydneyCurrentTime", sydneyCurrentTime); //time formate "16/03/2025, 00"
        const currentHour = sydneyCurrentTime.split(", ")[1];
        let newFilteredData = [];

        if (data.history) {
          data.history.slice(-2).forEach((entry) => {
            const date = new Date(entry.time); // convert to AU time zone
            const hour = formatter.format(date).split(", ")[1];
            newFilteredData.push({ hour, uvi: entry.uvi });
          });
        }

        // Include 'now' data point
        newFilteredData.push({
          hour: currentHour,
          uvi: data.now.uvi,
          current: true,
        });

        if (data.forecast) {
          // 18 means the upcoming 10 hours
          data.forecast.slice(0, 10).forEach((entry) => {
            const date = new Date(entry.time); // convert to AU time zone
            const hour = formatter.format(date).split(", ")[1];
            newFilteredData.push({ hour, uvi: entry.uvi });
          });
        }
        setFilteredData(newFilteredData);

        console.log("UV filtered data", newFilteredData);

        // if (data.hourly && data.hourly.length > 12) {

        // } else {
        //   setErrorMessage("No UV index data available.");
        // }
      } catch (error) {
        console.error("Error fetching UV index:", error);
        setErrorMessage("Failed to retrieve UV index.");
      }
    };

    fetchUVIndex();
  }, [lat, lng]);

  if (filteredData.length === 0) {
    return <p>Loading UV Index data...</p>;
  }

  return (
    <div>
      <h3>UV Index (Last 2 Hours + Next 10 Hours)</h3>
      {errorMessage ? (
        <p style={{ color: "red" }}>{errorMessage}</p>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={filteredData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="hour" tickFormatter={(tick) => `${tick}:00`} />
            <YAxis
              label={{ value: "UV Index", angle: -90, position: "insideLeft" }}
            />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="uvi"
              stroke="#D926A9"
              strokeWidth={3}
              // dot={{ r: 3 }}
              dot={{ fill: "#FFFFFF", r: 3 }}
            />
            {/* Highlight current UV index */}
            {filteredData.map((entry, index) =>
              entry.current ? (
                <ReferenceDot
                  key={index}
                  x={entry.hour}
                  y={entry.uvi}
                  r={6}
                  fill="red"
                  stroke="red"
                />
              ) : null
            )}
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default UVIndexChart;
